import { Group, Stack, Text, ThemeIcon } from '@mantine/core';

/** The client-facing lockup: Makin Laboratories Pvt. Ltd. · RA Portal (staff see the MExP mark). */
export function PortalMark({ inverse = false, compact = false }: { inverse?: boolean; compact?: boolean }) {
  return (
    <Group gap={10} wrap="nowrap">
      <ThemeIcon size={36} radius="md" variant={inverse ? 'white' : 'filled'} c={inverse ? 'brand.9' : undefined} aria-hidden>
        <svg viewBox="0 0 64 64" width="22" height="22">
          <path d="M16 46V18h6l10 14 10-14h6v28h-7V30l-9 12-9-12v16z" fill="currentColor" />
        </svg>
      </ThemeIcon>
      {!compact && (
        <Stack gap={0}>
          <Text fw={700} lh={1.15} fz="md" c={inverse ? 'white' : undefined}>
            Makin Laboratories Pvt. Ltd.
          </Text>
          <Text fz={12} lh={1.25} c={inverse ? 'brand.1' : 'dimmed'}>
            RA Portal
          </Text>
        </Stack>
      )}
    </Group>
  );
}
